module.exports = __webpack_public_path__ + "img/button_map_reunies.0d6a0003.svg";